package com.shmbles.web.sections

import androidx.compose.runtime.Composable
import com.shmbles.web.models.Section
import com.shmbles.web.models.Theme
import com.shmbles.web.styles.FooterLinkStyle
import com.shmbles.web.styles.SocialLinkStyle
import com.shmbles.web.util.Constants.FONT_FAMILY
import com.shmbles.web.util.Constants.GITHUB_PROJECTS
import com.shmbles.web.util.Constants.LINKEDIN
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.icons.fa.FaGithub
import com.varabyte.kobweb.silk.components.icons.fa.FaLinkedin
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FooterSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Theme.Secondary.rgb)
            .padding(topBottom = if (breakpoint >= Breakpoint.MD) 50.px else 35.px),
        contentAlignment = Alignment.Center
    ) {
        FooterContent()
    }
}

@Composable
fun FooterContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Social icons
        Row(
            modifier = Modifier.margin(bottom = 25.px),
            horizontalArrangement = Arrangement.Center
        ) {
            Link(
                path = GITHUB_PROJECTS,
                openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
            ) {
                FaGithub(
                    modifier = SocialLinkStyle.toModifier().margin(right = 20.px),
                    size = IconSize.LG
                )
            }
            Link(
                path = LINKEDIN,
                openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
            ) {
                FaLinkedin(
                    modifier = SocialLinkStyle.toModifier(),
                    size = IconSize.LG
                )
            }
        }

        // Nav links
        Row(
            modifier = Modifier
                .styleModifier { property("flex-wrap", "wrap") }
                .margin(bottom = 25.px),
            horizontalArrangement = Arrangement.Center
        ) {
            listOf(Section.Home, Section.About, Section.Service, Section.Companies).forEach { section ->
                Link(
                    modifier = FooterLinkStyle.toModifier()
                        .padding(leftRight = 10.px, topBottom = 5.px)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(14.px)
                        .fontWeight(FontWeight.Normal)
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path,
                    text = section.title
                )
            }
        }

        // Divider
        Box(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 60.percent else 80.percent)
                .height(1.px)
                .backgroundColor(Theme.Gray.rgb)
                .margin(bottom = 20.px)
        )

        // Copyright
        val currentYear = kotlin.js.Date().getFullYear()
        P(
            attrs = Modifier
                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(13.px)
                .fontWeight(FontWeight.Normal)
                .color(Theme.Gray.rgb)
                .textAlign(TextAlign.Center)
                .toAttrs()
        ) {
            Text("© $currentYear Andres Diaz · Made with Kobweb")
        }
    }
}
